<h1 mat-dialog-title>System Maintenance</h1>
<div mat-dialog-content>
  <p>
    The system is undergoing routine maintenance and will be back online shortly. 
  </p>
</div>
